'use strict';

import { GLOBAL } from './Global';
import { SALES as SALES_PERMISSION_GROUPS } from '../PermissionsGroups';

const sales_permissions_list = [];

for (const [key, value] of Object.entries(SALES_PERMISSION_GROUPS)) {
  sales_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const SALES = {
  can: [
    ...GLOBAL.can,
    ...sales_permissions_list,
  ],
};

export {
  SALES,
};
